export default __webpack_public_path__ + "static/media/questionMark.98ea9f5c.png";